import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import WebinarList from "components/Admin/ClientUrls/AddWebinars";
import ToolsAddWebinars from "components/Admin/ClientUrls/AddWebinars/Toolbar";

const { loadAdminWebinarsSaga, setTempClientUrl, loadClientUrlSagaAdmin } =
  actions;

class AddWebinars extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      webinar_ids:
        props.temp && props.temp.webinar_ids ? props.temp.webinar_ids : [],
      page: props.page || 1,
      query: {
        title: "",
        date_from: null,
        date_to: null,
        order: {
          created_at: "desc",
        },
      },
    };
  }

  componentWillReceiveProps(props) {
    if (props.clientUrl && !_.isEqual(this.props.temp, props.clientUrl)) {
      let webinar_ids = props.clientUrl.webinar_ids;

      this.setState({
        webinar_ids,
      });

      this.props.setTemp(this.props.clientUrl);
    }
  }

  componentWillMount = () => {
    this.loadWebinars();

    if (this.props.params.id && _.isEmpty(this.props.temp))
      this.props.loadClientUrl(this.props.params.id);
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.loadWebinars
    );
  };

  checkedWebinarIds = (webinar_id) => {
    var ids = _.assign(this.state.webinar_ids),
      index = this.state.webinar_ids.indexOf(webinar_id);

    if (index == -1) {
      ids.push(webinar_id);
    } else {
      ids.splice(index, 1);
    }
    this.setState({ webinar_ids: ids });
  };

  loadWebinars = () =>
    this.props.loadWebinars(this.state.page, this.state.query);

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadWebinars, timeout);
    });
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order,
      },
    };
    this.changeQuery(query, 0);
  };

  onChangeQuery = (field, value) => {
    const query = { ...this.state.query, ...{ [field]: value } };
    this.setState({ page: 1 }, () => {
      this.changeQuery(query);
    });
  };

  onAddCheckedWebinarsClick = () => {
    this.props.setTemp({
      ...this.props.temp,
      ...{
        webinar_ids: this.state.webinar_ids,
      },
    });

    if (this.props.temp.id) {
      return this.props.router.push({
        pathname: `/client-url/${this.props.params.id}/edit`,
        state: { from: "addWebinars" },
      });
    }

    this.props.router.push({
      pathname: `/client-url/new`,
      state: { from: "addWebinars" },
    });
  };

  render() {
    return (
      <main className="site--width clearfix container_statistics">
        <ToolsAddWebinars
          count={this.state.webinar_ids.length}
          onAddCheckedWebinarsClick={this.onAddCheckedWebinarsClick}
          onChangeQuery={this.onChangeQuery}
          onDateRangeChange={this.onDateRangeChange}
          query={this.state.query}
        />
        <div className="admin_webinars_table admin_table">
          <WebinarList
            role={this.props.role}
            webinars={this.props.webinars}
            checkedWebinarIds={this.checkedWebinarIds}
            webinar_ids={this.state.webinar_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    webinars: state.webinars.adminWebinars.values,
    count: state.webinars.adminWebinars.count,
    total_pages: state.webinars.adminWebinars.total_pages,
    page: state.webinars.adminWebinars.page,
    query: state.webinars.adminWebinars.query,
    temp: state.clientUrls.admin.temp,
    clientUrl: state.clientUrls.admin.clientUrl,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    loadWebinars: (page, query) => dispatch(loadAdminWebinarsSaga(page, query)),
    setTemp: (clientUrl) => dispatch(setTempClientUrl(clientUrl)),
    loadClientUrl: (id) => dispatch(loadClientUrlSagaAdmin(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddWebinars);



// WEBPACK FOOTER //
// ./src/containers/Admin/ClientUrls/AddWebinarsList.jsx